import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes.add', {
        url: '/shared-notes/add',
        views: {
            '@company.sharing-center': 'companySharingCenterSharedNotesAdd'
        },
        
    });
}





// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/add/add-shared-note.state.js